import httpClient from './httpClient'

const END_POINT = '/api/pago_tipos'

const getAll = async () => await httpClient.get(END_POINT)

export {

    getAll

}